import { QueryClient } from "@tanstack/react-query"
import { type GetStaticPropsContext, type InferGetStaticPropsType } from "next"
import { getStoryblokLayout, StoryTemplate } from "@/features/storyblok"
import { withStoryProps } from "@/features/storyblok/server"

type HomePageProps = InferGetStaticPropsType<typeof getStaticProps>

export default function HomePage({ story, preview }: HomePageProps) {
    return (
        <StoryTemplate
            story={story}
            preview={preview}
        />
    )
}

HomePage.getLayout = getStoryblokLayout
HomePage.messages = [...getStoryblokLayout.messages] as const

export async function getStaticProps(context: GetStaticPropsContext) {
    const queryClient = new QueryClient()

    return withStoryProps({
        slug: "home", // Change this value in Storyblok to change the home page
        queryClient,
        context,
        intlNamespaces: HomePage.messages,
        props: {},
    })
}
